export default function riskStatus(status) {
    switch (status) {
        case 'draft': return 'Draft';
        case 'requested': return 'Requested';
        case 'in_the_market': return 'In the market';
        case 'reviewing': return 'Reviewing';
        case 'firm_order': return 'Firm order';
        case 'firm_order_requested': return 'Firm order requested';
        case 'pending': return 'Pending';
        case 'offered': return 'Offered';
        case 'accepted': return 'Accepted';
        case 'approved': return 'Approved';
        case 'declined': return 'Declined';
        case 'captive_reviewing': return 'Captive reviewing';
        case 'captive_approved': return 'Captive approved';
        case 'ntu': return 'NTU';
        case 'not_taken_to_market': return 'Not taken to market';
        case 'expired': return 'Expired';
        case 'cancelled': return 'Cancelled';
        case 'closed': return 'Closed';
        case 'firm_ordered': return 'Firm ordered';
        case 'bound': return 'Bound';
        case 'query': return 'Query';
        case 'off_risk': return 'Off risk';
        case 'off_risk_amendment': return 'Off risk';
        case 'in_progress': return 'In progress';
        case 'interested': return 'Interested';
        case 'executed': return 'Executed';
        case 'not_required': return 'Not Required';

        default: return status;
    }
}
